import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers } from 'recompose';
import Select from 'react-select';
import { List } from 'immutable';

import { ResourceStatuses } from './contants';
import formControl from '../formControl';
import * as styles from '../styles.css';
import { useTranslation } from 'react-i18next';



function ResourceStatusSelect({ input, onChange, multi, disabled, isEditable, clearable }) {

  const { t } = useTranslation();

  const options = [
    { value: ResourceStatuses.ACTIVE, label: t('Aktiv') },
    { value: ResourceStatuses.DUPLICATE, label: t('Dubblett') },
    { value: ResourceStatuses.UNPROCESSED, label: t('Ej bearbetad') },
    { value: ResourceStatuses.NOT_INTERESTED, label: t('Ej intresserad') },
    { value: ResourceStatuses.IMPORTED, label: t('Import') },
    { value: ResourceStatuses.INFORMATION_MISSING, label: t('Information saknas') },
    { value: ResourceStatuses.EVENING, label: t('Sök kväll') },
    { value: ResourceStatuses.WARNING, label: t('VARNING') },
    { value: ResourceStatuses.NOT_QUALIFIED, label: t('Ej kvalificerad') },
    { value: ResourceStatuses.TEMPORARY, label: t('Visstid') },
    { value: ResourceStatuses.PERMANENT, label: t('Tillsvidare') },
    { value: ResourceStatuses.NEEDS, label: t('Behov') },
    { value: ResourceStatuses.INTERNSHIP, label: t('Praktik') },
    { value: ResourceStatuses.TO_CUSTOMER, label: t('Övergått till kund') },
    { value: ResourceStatuses.COMPLETED, label: t('Avslutats') },
    { value: ResourceStatuses.SELF_RESIGN, label: t('Egen uppsägning') },
    { value: ResourceStatuses.PERSONAL_RESIGN, label: t('Uppsagd personliga skäl') },
    { value: ResourceStatuses.EMPLOYED_WITH_SUBSIDY, label: t('Visstid med bidrag') },
    { value: ResourceStatuses.UNBOOKED, label: t('Obokad') },
    { value: ResourceStatuses.PERMANENT_EMPLOYED_WITH_SUBSIDY, label: t('Tillsvidare med bidrag') },
  ];

  if (!isEditable && !multi) {
    const option = options.find(({ value }) => value === input.value);
    const label = option ? option.label : t('Status saknas...');
    return <div className={styles.value}>{label}</div>;
  }

  return (
    <div style={{ width: '100%' }} data-testid="ResourceStatusSelect">
      <Select
        name={input.name}
        placeholder={t("Status...")}
        options={options}
        value={List.isList(input.value) ? input.value.toJS() : input.value}
        onChange={onChange}
        multi={multi}
        disabled={disabled}
        clearable={clearable}
      />
    </div>
  );
}

ResourceStatusSelect.defaultProps = {
  input: {
    name: 'resourceStatusSelect',
    value: undefined,
  },
  multi: false,
  disabled: false,
  clearable: true,
  isEditable: true,
};

ResourceStatusSelect.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(List), PropTypes.number]),
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  multi: PropTypes.bool,
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool,
  clearable: PropTypes.bool,
};

export default compose(
  formControl,
  withHandlers({
    onChange: ({ input, multi }) => (value) => {
      if (!multi) {
        if (value) {
          input.onChange(value.value);
        } else {
          input.onChange(value);
        }
        return;
      }

      if (!value) {
        input.onChange(new List());
        return;
      }
      input.onChange(new List(value));
    },
  }),
)(ResourceStatusSelect);
